import React from 'react';
import { Select } from 'antd';

/*
  Possible props to pass:
  - className: string that is aditionally added to default className
  - elements: array => [{id: "Int", name: "String"}]
  - onChange: function that is called onChange and returns the new selected Element
  - onSelect: function that is called when a new element is selected
  - onDeselect: function that is called when a selected element is deselected
  - onMouseEnter: function that is called when the mouse enters the component
  - onMouseLeave: function that is called when the mouse leaves the component
  - onFocus: function that is called when the component is put into focus
  - selectedElements: array of ids
  - placeholder: placeholder string
  - disabled: dropdown is disabled
  - showSearch: show search input
  - allowClear: selected value can be cleared
*/

export interface AntMultiSelectProps {
  className?: string;
  popupClassName?: string;
  elements: {
    id: string | number;
    name: string;
  }[];
  onChange?: (value: number[]) => void;
  onSelect?: (value: number, option: any) => void;
  onDeselect?: (value: number, option: any) => void;
  onMouseEnter?: React.MouseEventHandler<HTMLElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLElement>;
  onFocus?: React.FocusEventHandler<HTMLElement>;
  selectedElements: number[];
  placeholder?: string;
  size?: 'small' | 'middle' | 'large';
  disabled?: boolean;
  showSearch?: boolean;
  allowClear?: boolean;
  style?: React.CSSProperties;
  suffixIcon?: React.ReactNode;
  loading?: boolean;
}

const AntMultiSelect: React.FC<AntMultiSelectProps> = ({
  className,
  popupClassName,
  elements,
  onChange,
  onSelect,
  onDeselect,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  selectedElements,
  placeholder,
  size,
  disabled,
  showSearch,
  allowClear,
  style,
  suffixIcon,
  loading,
}) => (
  <Select
    mode="multiple"
    value={selectedElements}
    onChange={onChange}
    onSelect={onSelect}
    onDeselect={onDeselect}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onFocus={onFocus}
    placeholder={placeholder}
    size={size}
    allowClear={allowClear}
    showSearch={showSearch}
    optionFilterProp="label"
    disabled={disabled}
    className={className}
    popupClassName={popupClassName}
    getPopupContainer={trigger => (trigger && trigger.parentNode) || document.body}
    options={elements.map(element => ({
      key: element.id,
      value: element.id,
      label: element.name,
    }))}
    style={style}
    suffixIcon={suffixIcon}
    loading={loading}
  />
);

export default AntMultiSelect;
